import { useMutation } from "@apollo/client";
import { useEffect } from "react";

import { RefreshTokenMutation, RefreshTokenMutationVariables, StorageKey } from "@ctypes";
import { REFRESH_TOKEN } from "@graphql";

const REFRESH_INTERVAL = 120000;

export const useRefreshToken = () => {
  const [refreshToken] = useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
    REFRESH_TOKEN,
  );

  useEffect(() => {
    const timer = setInterval(async () => {
      const token = localStorage.getItem(StorageKey.Token);

      if (token) {
        try {
          const { data } = await refreshToken({
            variables: { token },
          });
          const newToken = data?.refreshToken.sessionJwt;

          if (newToken) {
            localStorage.setItem(StorageKey.Token, newToken);
          }
        } catch {}
      }
    }, REFRESH_INTERVAL);

    return () => {
      clearInterval(timer);
    };
  }, [refreshToken]);
};
